import { skipToken } from "@reduxjs/toolkit/query";
import { styled } from "styled-components";

import { useGetDimensionQuery } from "api/dimensionApi.slice";
import { EditIcon } from "common/components";
import { useDispatch, useSelector } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";
import { getNewCustomDimensions } from "domains/createMapDetail/selectors";
import { toggleCustomKeyIssueForm } from "domains/customKeyIssue/actions";

const StyledButton = styled.button<{ isPending: boolean }>`
  transition: 0.3s;
  color: ${({ theme }) => theme.colors.textFade};
  background: none;
  border: none;
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => theme.colors.activeButtonHoverBackground};
    color: ${({ theme }) => theme.colors.textBright};
  }
`;

const StyledEditIcon = styled(EditIcon)`
  width: 12px;
  height: 12px;
  padding-right: 1rem;
`;

type EditCustomKeyIssueButtonProps = { id: string; onEditSelect?: (id: string) => void };

export const EditCustomKeyIssueButton = ({ id, onEditSelect: onEdit }: EditCustomKeyIssueButtonProps) => {
  const dispatch = useDispatch();
  const newCustomDimensions = useSelector(getNewCustomDimensions);
  const translate = useTranslate();

  const arg = newCustomDimensions.some((dimension) => dimension.id === id) ? skipToken : { id };
  const getDimensionQuery = useGetDimensionQuery(arg);

  const onEditClick = () => {
    dispatch(toggleCustomKeyIssueForm({ id, isActive: true }));
    onEdit?.(id);
  };

  return (
    <StyledButton
      data-test-id="edit-custom-key-issue-button"
      isPending={getDimensionQuery.isFetching}
      onClick={onEditClick}
    >
      <StyledEditIcon />
      {translate("app.topic.actions.edit")}
    </StyledButton>
  );
};
